import { createContentPropTypes } from '../../helpers/content';

const businessCutOffModalContent = {
	modalTitle: 'Payment deadline missed',
	modalBody:
		'International payments can only be authorised and processed up until your chosen currency’s cut-off time on business banking days. This payment will need to be authorised on the next available business day. Please note this will affect the earliest estimated settlement date',
	modalAuthoriseLaterButton: 'Authorise later',
	modalCancelPaymentButton: 'Cancel payment',
};

const chapsBusinessCutOffModalContent = {
	...businessCutOffModalContent,
	modalTitle: 'CHAPS payment deadline',
	modalBody: 'Please remember that CHAPS payments must be authorised by 5pm to meet your planned payment date.',
};

export default { businessCutOffModalContent, chapsBusinessCutOffModalContent };

export const contentPropTypes = createContentPropTypes(businessCutOffModalContent);
